<mat-toolbar class="mat-primary">
  <span fxFlex>
    <mat-icon class="icon-modal-message" *ngIf="inputData.error">error</mat-icon>
    {{ inputData.title }}
  </span>
  <mat-icon class="cursor-mat-element" (click)="cancel()">close</mat-icon>
</mat-toolbar>
<mat-dialog-content>
  <div flex fxLayout="column" fxLayoutAlign="center">
    <h3 style="padding: 4rem; padding-top: 80px; text-align: center">
      {{ inputData.message }}
    </h3>
  </div>

  <div class="button-container" fxLayout="row" fxLayoutAlign="end stretch" fxLayoutGap="20px">
    <button
      mat-stroked-button
      color="primary"
      id="modal-cancel-button"
      *ngIf="inputData.cancelText"
      (click)="cancel()">
      {{ inputData.cancelText }}
    </button>

    <button mat-raised-button color="primary" id="modal-confirm-button" (click)="confirm()">
      {{ inputData.confirmText }}
    </button>
  </div>
</mat-dialog-content>
